import React from "react";
import { Crown } from "lucide-react";
import { RegisterForm } from "../components/RegisterForm";
import { useI18n } from "../i18n";

export default function Register() {
  const { t } = useI18n();
  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <div className="text-center mb-6">
        <Crown className="h-8 w-8 text-neon-magenta mx-auto mb-2" />
        <h1 className="font-anton text-4xl uppercase text-white">{t("reg.title")}</h1>
        <p className="text-zinc-500 text-sm">{t("reg.sub")}</p>
      </div>
      <RegisterForm />
    </div>
  );
}
